import { StateNode } from './StateNode';
export function Machine(config, options) {
  return new StateNode(config, options);
}